import { Payment } from '@wajeez/wajeez.microservices';

const PLANS = 'plans';

export const setPlans = (plans: Payment.PlanOutput[]) => {
  localStorage.setItem(PLANS, JSON.stringify(plans));
};

export const getPlans = () => {
  const plans = localStorage.getItem(PLANS);

  return plans ? JSON.parse(plans) : null;
};

export const removePlans = () => {
  localStorage.removeItem(PLANS);
};
